import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

const FundingEnquiryUrgencyRecord = Record({
  id: 0,
  value: '',
});

export default class FundingEnquiryUrgency extends FundingEnquiryUrgencyRecord {
  static deserialize(jsonObject = {}) {
    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, {}), {});

    return new FundingEnquiryUrgency(hydrated);
  }
}
